<!-- Head Template -->
<ng-template #dialogHead>
  <label class="label-title">Change Bill Run Time</label>
  <button mat-icon-button (click)="onClose()" class="custom-mat-icon-button button-close-panel">
    <mat-icon svgIcon="ico-close" class="custom-mat-icon ico-size ico-2xs"></mat-icon>
  </button>
</ng-template>

<!-- Body Template -->
<ng-template #dialogBody>
  <div class="form-wrapper fluid-max max-400">
    <div class="form-content">
      <div class="form-section">
        <div class="form-section-container">
          <div class="form-section-body">
            <div class="form-row">
              <mat-form-field class="p-4 custom-mat-form-field size size1of1">
                <mat-label>Run Time</mat-label>
                <mat-select class="custom-mat-select select-address-books" [(ngModel)]="selectedRunTime" name="operationTime">
                  <mat-option  [matTooltip]="item['disabled'] ? 'Running time must be at least 30 minutes after current time.': ''" matTooltipPosition="above"  [disabled]="item['disabled']" *ngFor="let item of _collectionOfTimes" [value]="item.value">{{item.label}}</mat-option>
                </mat-select>
              </mat-form-field>
  
              <mat-form-field class="p-4 date-time-input custom-mat-form-field field-date-picker size size1of1" >
                <mat-label>Run Date</mat-label>
                <input matInput  (dateChange)="onChangeDate()" [min]="minDate"  [formControl]="dateControl"  [matDatepicker]="picker">
                <mat-datepicker #picker></mat-datepicker>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>

              </mat-form-field>
            </div>
            <div class="form-row">
              <section class="message message-row">
                <div class="message-wrapper info">
                  <div class="message-inner">
                    <p class="typo label fw400 semi-condensed">If the time selected match with a Bill Run in process it will change the date of the Bill Run to the next day available .</p>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<!-- Nav Template -->
<ng-template #dialogNav>
  <button mat-flat-button (click)="onSubmit()" color="primary" class="mat-button custom-mat-button-primary">Update Run Time</button>
</ng-template>

<!-- Dialog -->
<app-dialog
  [dialogHead]="dialogHead"
  [dialogBody]="dialogBody"
  [dialogNav]="dialogNav">
</app-dialog>
